import { render, staticRenderFns } from "./GatGridGroopFooter.vue?vue&type=template&id=d3f1d56c&scoped=true&"
import script from "./GatGridGroopFooter.vue?vue&type=script&lang=js&"
export * from "./GatGridGroopFooter.vue?vue&type=script&lang=js&"
import style0 from "./GatGridGroopFooter.vue?vue&type=style&index=0&id=d3f1d56c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f1d56c",
  null
  
)

export default component.exports